import {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  useContext,
} from "react";

export interface CoralPreviewOverride {
  storyId: string;
  /** Staging permalink for the pinned story (must match `storyId` in Coral). */
  storyUrl?: string;
}

const CoralPreviewOverrideContext = createContext<CoralPreviewOverride | null>(
  null,
);

interface ProviderProps extends PropsWithChildren {
  override: CoralPreviewOverride | null;
}

/** CSK dev preview: optional overrides for Coral embed `storyID` / `storyURL`. */
export const CoralPreviewOverrideProvider: FunctionComponent<ProviderProps> = ({
  override,
  children,
}) => {
  return (
    <CoralPreviewOverrideContext.Provider value={override}>
      {children}
    </CoralPreviewOverrideContext.Provider>
  );
};

export function useCoralPreviewOverride(): CoralPreviewOverride | null {
  return useContext(CoralPreviewOverrideContext);
}
